// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"424":"ec2cd974","444":"28a71eed","548":"01cf91e3","680":"74989534","720":"89218780","892":"25c7aca1","940":"7a3039d4"}[chunkId] + ".chunk.js";
};